module.exports = __webpack_public_path__ + "static/0009-30c6240ca53584d534d5751927aedc36.png";